import { render } from "./App.vue?vue&type=template&id=caf35ab6"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=caf35ab6&lang=scss"

import exportComponent from "D:\\Lessons\\Vuew\\Azbyka\\dobroazbyka\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__